import { useSegmentAnalytics } from "./useSegmentAnalytics";

export const useQuestionnairePageAnalytics = () => {
  const { trackButtonClickEvent, trackLinkClickEvent, trackOptionClickEvent } =
    useSegmentAnalytics();

  // Introduction Form
  const trackIntroductionGetStartedEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire startup screen - Start now button",
      location: "Questionnaire startup screen - Start now button",
      extraProperties: {
        event_type: "Click",
        link_text: "Start now button",
      },
    });

  const trackIntroductionBackToDashboardEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire startup screen - Back to dashboard button",
      location: "Questionnaire startup screen - Back to dashboard button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back to dashboard button",
      },
    });

  // Business Info Form
  const trackBusinessInfoBackEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire step 1 screen - Back button",
      location: "Questionnaire step 1 screen - Back button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back button",
      },
    });

  const trackBusinessInfoSaveAndContinueEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire step 1 screen - Save and continue button",
      location: "Questionnaire step 1 screen - Save and continue button",
      extraProperties: {
        event_type: "Click",
        link_text: "Save and continue button",
      },
    });

  // License Info Form
  const trackLicenseInfoBackEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire step 2 screen - Back button",
      location: "Questionnaire step 2 screen - Back button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back button",
      },
    });

  const trackLicenseInfoSaveAndContinueEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire step 2 screen - Save and continue button",
      location: "Questionnaire step 2 screen - Save and continue button",
      extraProperties: {
        event_type: "Click",
        link_text: "Save and continue button",
      },
    });

  // Clients Info Form
  const trackClientsInfoBackEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire step 3 screen - Back button",
      location: "Questionnaire step 3 screen - Back button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back button",
      },
    });

  const trackClientsInfoSaveAndContinueEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire step 3 screen - Save and continue button",
      location: "Questionnaire step 3 screen - Save and continue button",
      extraProperties: {
        event_type: "Click",
        link_text: "Save and continue button",
      },
    });

  // Review Form
  const trackReviewBackEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire Review screen - Back button",
      location: "Questionnaire Review screen - Back button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back button",
      },
    });

  const trackReviewEditEvent = (section: string) =>
    trackButtonClickEvent({
      label: `Questionnaire Review screen - ${section} Edit button`,
      location: `Questionnaire Review screen - ${section} Edit button`,
      extraProperties: {
        event_type: "Click",
        link_text: `${section} Edit button`,
      },
    });

  const trackReviewSubmitEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire Review screen - Submit button",
      location: "Questionnaire Review screen - Submit button",
      extraProperties: {
        event_type: "Click",
        link_text: "Submit button",
      },
    });

  const trackReviewCheckboxEvent = (
    name: string,
    text: string,
    checked: boolean,
  ) =>
    trackOptionClickEvent({
      label: `Questionnaire Review screen - ${name} checkbox`,
      location: `Questionnaire Review screen - ${name} checkbox`,
      extraProperties: {
        event_type: `Option clicked (${name} checkbox)`,
        link_text: text,
        element_name: checked ? "TRUE" : "FALSE",
      },
    });

  // Success Form
  const trackSuccessGoToDashboardEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire success screen - Back to dashboard button",
      location: "Questionnaire success screen - Back to dashboard button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back to dashboard button",
      },
    });

  // Back to Dashboard (Footer Link)
  const trackBackToDashboardEvent = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) =>
    trackLinkClickEvent({
      event,
      label: "Questionnaire ALL screens - Back to dashboard link",
      location: "Questionnaire ALL screens - Back to dashboard link",
      extraProperties: {
        event_type: "Click",
        link_text: "Back to dashboard link",
      },
    });
  // Back to Dashboard (Mobile Close Button)
  const trackBackToDashboardButtonEvent = () =>
    trackButtonClickEvent({
      label: "Questionnaire ALL screens - Back to dashboard button",
      location: "Questionnaire ALL screens - Back to dashboard button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back to dashboard button",
      },
    });

  return {
    trackIntroductionGetStartedEvent,
    trackBusinessInfoBackEvent,
    trackBusinessInfoSaveAndContinueEvent,
    trackLicenseInfoBackEvent,
    trackLicenseInfoSaveAndContinueEvent,
    trackClientsInfoBackEvent,
    trackClientsInfoSaveAndContinueEvent,
    trackReviewBackEvent,
    trackReviewEditEvent,
    trackReviewSubmitEvent,
    trackReviewCheckboxEvent,
    trackSuccessGoToDashboardEvent,
    trackBackToDashboardEvent,
    trackBackToDashboardButtonEvent,
    trackIntroductionBackToDashboardEvent,
  };
};
